import { render, staticRenderFns } from "./AddPhysicalExam.vue?vue&type=template&id=2adf0442&scoped=true"
import script from "./AddPhysicalExam.vue?vue&type=script&lang=js"
export * from "./AddPhysicalExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf0442",
  null
  
)

export default component.exports